import { html } from '@nrk/dh-server-libs/html'
import styles from './lydlogg.module.css'
import { nrkMediaPause, nrkMediaPlay } from '@nrk/core-icons'

export function renderPlayButton(playing) {
  return html` <button class="${styles.togglePlayButton}">${renderPlayButtonText(playing)}</button>`
}

export function renderPlayButtonText(playing) {
  return html`<span class="nrk-sr">${playing ? 'Sett lyden på pause' : 'Spill av lyd'}</span>
    ${playing ? nrkMediaPause : nrkMediaPlay}`
}
